import {Component, Input, OnInit} from '@angular/core';
import {WorkflowInstanceModel} from "../../../../models/workflow/workflow-instance.model";
import {WorkflowStepDnaExtractionModel} from "../../../../models/workflow-step/workflow-step-dna-extraction.model";
import {PositionModel} from "../../../../models/Plate/position.model";
import {PlateMode} from "../../../../enums/PlateMode";
import {WorkflowDetailClientService} from "../../../dialog/workflow-detail-dialog/workflow-detail-client.service";
import {BatchType} from "../../../../enums/BatchType";
import {WorkflowStep} from "../../../../enums/WorkflowStep";
import {UntypedFormArray} from "@angular/forms";
import {BatchModel} from "../../../../models/batch/batch.model";

@Component({
  selector: 'app-dna-extraction',
  templateUrl: './dna-extraction.component.html',
  styleUrls: ['./dna-extraction.component.scss']
})
export class DnaExtractionComponent implements OnInit {
  WorkflowStep = WorkflowStep;

  BatchType = BatchType;
  PlateMode = PlateMode;
  batchFormArray: UntypedFormArray;
  private isInitializing: boolean = true;

  @Input() workflowInstance: WorkflowInstanceModel;
  @Input() workflowStep: WorkflowStepDnaExtractionModel;
  @Input() readOnly: boolean = false;

  showDetail = false;
  selectedPosition: PositionModel;

  constructor(public workflowDetailClientService: WorkflowDetailClientService) {
  }

  ngOnInit(): void {
    this.batchFormArray = BatchModel.initFormArrayForBatchSelection(this.workflowStep.batches, true, false);
    this.validateStep();
    this.isInitializing = false;
  }

  validateStep() {
    this.workflowStep.batches = BatchModel.getBatchesFromBatchSelectionFormArray(this.batchFormArray);
    this.workflowDetailClientService.isStepValid$.next(this.workflowStep.isValid());

    // Save the current state when changes occur to prevent data loss
    if (!this.readOnly && !this.isInitializing) {
      this.workflowDetailClientService.silentSave();
    }
  }

  openPositionDetail(position: PositionModel) {
    this.selectedPosition = position;
    this.showDetail = true;
  }

  onCellClick(position: PositionModel) {
    this.selectedPosition = position;
  }

  switchPlateToSwabLysisView() {
    this.workflowDetailClientService.fetchWorkflowInstanceStepByStep(WorkflowStep.DNA_EXTRACTION_SWAB_LYSIS);
  }

}
